<template>
    <div class="page-content">
        <base-screen>
            <el-form inline  ref="screenForm"
                     :model="screenData"
                     @keydown.native.enter="seachButton"
                     @submit.native.prevent>
                <el-form-item label="员工姓名：">
                    <el-input placeholder="员工姓名" v-model="screenData.name"></el-input>
                </el-form-item>
                <el-form-item label="性别：">
                    <el-select v-model="screenData.sex" placeholder="请选择">
                        <el-option label="男" value="1">男</el-option>
                        <el-option label="女" value="0">女</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="联系方式：">
                    <el-input placeholder="联系方式" v-model="screenData.phone"></el-input>
                </el-form-item>
                <el-form-item label="员工级别：">
                    <el-input placeholder="员工级别" v-model="screenData.typeName"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="seachButton">查询</el-button>
                    <el-button type="text" @click="resetSearchSubmit">重置</el-button>
                </el-form-item>
            </el-form>
        </base-screen>

        <div class="page-box">
            <div class="tr">
                <el-button type="primary" @click="$router.push(`${$route.path}/employeeType`)" v-pms="'addType'">+ 添加员工级别</el-button>
                <el-button type="primary" @click="$router.push(`${$route.path}/add`)" v-pms="'add'">+ 新建</el-button>
            </div>
            <el-table :data="data" v-loading="loading">
                <el-table-column
                  prop="name"
                  label="员工姓名" width="80px">
                    <template slot-scope="{row}">
                        <el-button type="text" class="link" @click="$router.push({path: `${$route.path}/look/${row.employeeId}`})" v-pms="'look'">{{row.name}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column
                  prop="sex"
                  label="性别"
                  width="60px" >
                    <template slot-scope="{row}">
                       <div v-if="row.sex==1">男</div>
                       <div v-if="row.sex==0">女</div>
                    </template>
                </el-table-column>
                <el-table-column
                  prop="deptName"
                  label="所属部门"
                ></el-table-column>
                <el-table-column
                  prop="typeName"
                  label="员工级别"
                ></el-table-column>
              <el-table-column prop="workingNum" label="服务中" width="70px">
                <template slot-scope="{row}">
                  <div v-if="row.workingNum && row.workingNum > 0">是</div>
                  <div v-else>否</div>
                </template>
              </el-table-column>
              <el-table-column prop="serviceNum" label="服务次数" width="80px">
                <template slot-scope="{row}">
                  <el-button type="text" class="link" @click="$router.push({path: `${$route.path}/order/${row.employeeId}`})" v-pms="'serviceNum'">{{row.serviceNum}}</el-button>
                </template>
              </el-table-column>
                <el-table-column prop="state" label="是否有效" width="80px">
                  <template slot-scope="{row}">
                    <el-switch
                      v-model="row.state"
                      @change="setEmployeeState(row.employeeId, row.state)"
                      active-value="1"
                      inactive-value="0">
                    </el-switch>
                  </template>
                </el-table-column>
              <el-table-column
                prop="serviceRange"
                label="服务范围" min-width="130px">
              </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="{row}">
                        <el-button type="text" @click="deleteEmployee(row)" v-pms="'del'">删除</el-button>
                        <el-button type="text" @click="$router.push({path: `${$route.path}/update/${row.employeeId}`})" v-pms="'edit'">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
              class="pagination"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.pageNum"
              :page-sizes="[10, 15, 20]"
              :page-size="page.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { employee } from '../../api'
export default {
  name: 'Employee',
  props: {
    deptId: {
      type: String,
      default: ''
    }
  },
  watch: {
    deptId (value) {
      this.page.pageNum = 1
      this.screenData.deptId = value
      this.getTableData()
    }
  },
  created () {
    this.callback = () => { this.getTableData() }
    this.$bus.$on('getTableData', this.callback)
  },
  destroyed () {
    this.$bus.$off('getTableData', this.callback)
  },
  mounted () {
    this.getTableData()
  },

  data () {
    return {
      loading: false,
      screenData: {
        name: '',
        sex: '',
        phone: '',
        typeName: '',
        orgCode: this.$store.state.user.orgCode,
        deptId: ''
      },
      page: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      data: []
    }
  },

  methods: {
    async getTableData () {
      this.loading = true
      let {data, page} = await employee.getEmployeePage({
        page: this.page,
        param: this.screenData
      })
      this.loading = false
      this.data = data
      this.total = page.total
      this.page.pageNum = page.pageNum
    },
    deleteEmployee ({employeeId, name}) {
      this.$confirm(`确定要删除员工[${name}]吗？`, '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let {code, msg} = await employee.delEmploye(employeeId)
        if (code === 0) {
          this.$message({
            type: 'success',
            message: '员工删除成功'
          })
          this.getTableData()
        } else {
          this.$message({
            type: 'error',
            message: msg || '员工删除失败'
          })
        }
      })
    },
    setEmployeeState (employeeId, state) {
      employee.setEmployeeState({ employeeId, state })
    },
    handleSizeChange (newPageSize) {
      this.page.pageSize = newPageSize
      this.getTableData()
    },
    handleCurrentChange (newPageNo) {
      this.page.pageNum = newPageNo
      this.getTableData()
    },
    seachButton () {
      this.page.pageNum = 1
      this.getTableData()
    },
    resetSearchSubmit () {
      this.$refs.screenForm.resetFields()
      this.page.pageNum = 1
      this.screenData.name = ''
      this.screenData.sex = ''
      this.screenData.phone = ''
      this.screenData.typeName = ''
      this.getTableData()
    }
  }
}
</script>

<style lang="scss" scoped>
    .edit-page {
        position: absolute;
        left: 20px;
        right: 20px;
        top: 20px;
        bottom: 20px;
        z-index: 1;
        background-color: white;
    }
</style>
